<template>
    <div class="unauthorized row justify-content-center align-items-center">
        <div class="unauthorized__filter"></div>
        <div class="unauthorized__card card mx-auto">
            <img src="../../assets/background/unauthorized_cover.png" class="card-img-top img-fluid">
            <div class="card-body">
                <div class="alert alert-warning" role="alert">
                    <h4 class="alert-heading">Academic Dean's Office</h4>
                    <hr>
                    <i class="fas fa-exclamation-triangle"></i> This resource is restricted and requires authorized
                    access. If you believe that you
                    should have access to this system, please contact your system administrator.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'unauthorized'
}
</script>

<style scoped>
.card-img-top {
    max-height: 250px;
}

.unauthorized {
    background: url(../../assets/background/unauthorized.jpg) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    margin: 0;
}

.unauthorized__card {
    max-width: 767px;
    border: 0;
    margin-bottom: 30px;
    margin-top: 30px;
    border-radius: 6px;
    color: rgba(0, 0, 0, .87);
    background: #fff;
    width: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
}

.unauthorized__filter {
    background: rgba(0, 0, 0, .5);
    display: block;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
}
</style>